import React from 'react'
import LeftSection from '../../login/LeftSection'
import UserLoginRightSection from './UserLoginRightSection'

function UserLogin() {
  return (
    <div className={'w-screen h-screen flex'}>
      <UserLoginRightSection />
      <LeftSection />
    </div>
  )
}

export default UserLogin
